import { ref } from "vue";
import type {  AxiosRequestConfig } from "axios";
import { useAuthStore } from "@/store/modules/auth";
import { localStg } from "@/utils/storage";
import { useAppStore } from "@/store/modules/app";
import { fetchPing, fetchRefreshToken } from "../api";
import { fetchExchangeRate } from "../api/data";
import { updateUserInfoFromResponse } from "@/utils/export";
import { logoutUser } from "@/service/api";
import { useUserStore } from "@/store/modules/user";
/**
 * refresh token
 *
 * @param axiosConfig - request config when the token is expired
 */
const pingInProgress = ref(false);

export async function handleRefreshToken(axiosConfig: AxiosRequestConfig) {
  const { resetStore } = useAuthStore();

  const refreshToken = localStg.get("refreshToken") || "";
  const { error, data } = await fetchRefreshToken(refreshToken);
  if (!error) {
    localStg.set("token", data.token);
    localStg.set("refreshToken", data.refreshToken);

    const config = { ...axiosConfig };
    if (config.headers) {
      config.headers.Authorization = data.token;
    }

    return config;
  }

  resetStore();

  return null;
}

export async function handlePingPong(force: boolean = false): Promise<boolean> {
  // Prevent multiple concurrent pings
  if (pingInProgress.value && !force) return false;

  pingInProgress.value = true;

  try {
    const { error, data, statusCode } = await fetchPing();
    const errorJSON = error?.toJSON() as any;
    // console.log("handlePingPong errorJSON: ", errorJSON);
    if (!error) {
     // Update user info with the response
     if (data) {
      updateUserInfoFromResponse(data);
     }
     return true;
    } else if (statusCode === 403 || errorJSON?.status === 403) {
      console.log("handlePingPong status is 403 going to clear the user auth state!: ", statusCode);
      logoutUser();
      const userStore = useUserStore();
      userStore.resetUserInfo();
      const authStore = useAuthStore();
      authStore.resetStore();
      return false;
    } else return false;
  } catch (error) {
    console.error("Unexpected error in ping:", error);
    return false;
  } finally {
    pingInProgress.value = false;
  }
}

export const updateExchangeRate = async () => {
  const appStore = useAppStore();

  try {
    const { error, data } = await fetchExchangeRate();
    if (!error && data && data.exchange_rate) {
      appStore.exchangeRate = data.exchange_rate;
    }
  } catch (error) {
    console.error(`Failed to fetch exchange rate:`, error);
  }
};
